import { FC, useEffect, useRef, useState } from "react";
import { LoaderFunction } from "react-router";
import MandirTabs from "~/components/daily-darshan/MandirTabs";
import DeepZoomViewer from "~/components/deep-zoom-view/DeepZoomViewer";
import BreadCrubComponent from "~/components/shared-components/BreadCrubComponent";
import { DZI_FILE_TYPE, getDhyanMurti } from "~/lib/store/slice/dhyanMurtiSlice";
import { useAppDispatch, useAppSelector } from "~/lib/store/store";
import { TilChinhData } from "~/utils/constant";
import { homeRouteString } from "~/utils/helper-funcations";

export const loader: LoaderFunction = async ({ params }) => {
  const lang = params.lang;
  const title = lang === "en" ? "Dhyan Murti" : "ધ્યાન મૂર્તિ";
  return {
    title,
  };
};

export const handle = {
  breadcrumb: (match: any) => {
    const lang = match.params.lang;
    return (
      <BreadCrubComponent
        breadCrub={[
          {
            path: homeRouteString(lang).path,
            title: homeRouteString(lang).home,
          },
        ]}
      />
    );
  },
  breadcrumbSchema: (match: any) => [
    { name: "Home", path: "/" },
    { name: match.data?.title || "Dhyan Murti", path: "/dhyan-murti" },
  ],
};
const TilChihn: FC = () => {
  const TYPE = "til-chinh";
  const dispatch = useAppDispatch();

  const { murtiList } = useAppSelector((state) => state.dhyanMurti);

  const [selectedOpt, setSelectedOpt] = useState<string>(TYPE);
  const [dziData, setDziData] = useState<DZI_FILE_TYPE | null>(null);
  const viewerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (viewerRef.current) {
        viewerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  // Handle mandir tab change
  const handleChangeMandir = (value: string) => {
    setSelectedOpt(value);
  };

  // Determine the DZI URL based on selected option
  useEffect(() => {
    const data: DZI_FILE_TYPE | undefined = murtiList.find((item) => item.key === selectedOpt);
    setDziData(data || null);
  }, [selectedOpt, murtiList]);

  useEffect(() => {
    dispatch(getDhyanMurti());
  }, []);

  return (
    <div ref={viewerRef} className="h-[calc(100dvh-150px)] md:h-[calc(100vh-200px)] -mt-5">
      <div className="my-5 flex justify-center items-center">
        <MandirTabs mandir={TilChinhData} setSelectedMandir={handleChangeMandir} selectedMandir={selectedOpt} />
      </div>

      <DeepZoomViewer
        dziUrl={dziData?.dziPath || ""}
        downloadUrl={dziData?.img || ""}
        downloadUrlHigh={dziData?.highImg || ""}
        imageWidth={4454}
        imageHeight={5434}
        config={{
          minZoom: 0.8,
          maxZoom: 60,
          springStiffness: 7,
          springAnimationTime: 1.2,
          zoomStep: 1.25,
        }}
        isWeb={true}
      />
    </div>
  );
};

export default TilChihn;
